import clsx from 'clsx';
import React from 'react';

const StarredItem = (props) => {
  const { title, filename, hasDocument, oldValue, newValue, actionTypeLabel, isDeleted } = props;

  return (
    <React.Fragment>
      <span className={clsx('tw-text-cfo-black')}> {actionTypeLabel} </span>
      {isDeleted ? (
        <strong className={clsx('tw-text-cfo-black tw-font-brandonTextBold !tw-font-normal')}>
          {hasDocument ? filename : oldValue || newValue}
        </strong>
      ) : (
        <a
          className={clsx(
            'tw-font-brandonTextBold tw-text-cfo-blue-600 tw-underline',
            'hover:!tw-underline hover:tw-text-cfo-blue-600'
          )}
          aria-hidden="true"
        >
          {hasDocument ? filename : ''}
        </a>
      )}

      {` ${title === 'Removed' ? ' from' : 'to'}  favorites`}
    </React.Fragment>
  );
};

export default StarredItem;
